import { Component, OnInit, Inject } from '@angular/core';
import { ValidationService } from '../validation.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { SnackbarService } from '../snackbar.service';
import { HttpService } from '../http.service';
import {Messages} from '../constants/messages'

@Component({
  selector: 'app-load-type',
  templateUrl: './load-type.component.html',
  styleUrls: ['./load-type.component.scss']
})
export class LoadTypeComponent implements OnInit {
  loadType: any = {
    name: '',
    type: 'Material',
    others: {
      l: 0,
      b: 0,
      h: 0
    }
  };

  messages = new Messages();
  constructor(private valid: ValidationService, private snackbar: SnackbarService, private dialog: MatDialogRef<LoadTypeComponent>, @Inject(MAT_DIALOG_DATA) private parentData: any, private http: HttpService) { }

  ngOnInit() {
  }
  addMaterial() {
    console.log('data -==-', this.loadType)
    if (this.valid.notEmpty(this.loadType.name)) {
      this.loadType.organization = this.parentData.organisation_id;
      this.http.post('utility/create', this.loadType).subscribe(
        (data: any) => {
          if (data.statusCode == 200) {
            this.snackbar.openSnackBar(this.messages.LOAD_TYPE.SUCCESS.MATERIAL_ADD, '');
            this.dialog.close({ material: data });
          }
        },
        (err: any) => {
          this.snackbar.openSnackBar(err.error.message, '', 'err');
          if (err.error.statusCode == 401) {
            this.valid.logout();
          }
        }
      );
    } else {
      this.snackbar.openSnackBar(this.messages.LOAD_TYPE.VALIDATION.FILL_MATERIAL_NAME, '', 'warn');
    }
  }

  closeDialog() {
    this.dialog.close();
  }
}
